module.exports = __webpack_public_path__ + "img/img67.5f5b82a2.png";